<template>
  <template v-if="isSubTable">
    <TableSubList
      :data="data"
      v-bind="$attrs"
      v-if="isSubListFlag"
      :formData="formData"
      :subFieldFormData="subFieldFormData"
    />
    <SubList
      :data="data"
      v-bind="$attrs"
      :formData="formData"
      :subFieldFormData="subFieldFormData"
    />
  </template>
  <template v-else>
    <TableField
      v-if="isSubListFlag"
      :data="data"
      v-bind="$attrs"
      :formData="formData"
      :subFieldFormData="subFieldFormData"
    />
    <SubField
      v-else
      :data="data"
      v-bind="$attrs"
      :formData="formData"
      :subFieldFormData="subFieldFormData"
    />
  </template>
</template>
<script lang="ts" setup>
import SubField from './subField.vue'
import SubList from './subList.vue'
import TableField from './tableField.vue'
import { computed, PropType } from 'vue'
import { isSubList } from '@/utils/preObjectManage/utils'
import TableSubList from './tableSubList.vue'
defineOptions({
  inheritAttrs: false
})
const props = defineProps({
  isSubTable: {
    type: Boolean,
    default: false
  },
  formData: {
    type: Object as PropType<Recordable>,
    default: () => {}
  },
  data: {
    type: Object as PropType<Recordable>,
    default: () => {}
  },
  subFieldFormData: {
    type: Object as PropType<Recordable>,
    default: () => {}
  }
})
// 判断是否是子表字段
const isSubListFlag = computed(() => {
  return isSubList(props.data.columnQuoteInfo?.quoteFieldType)
})
</script>
